// extracted by mini-css-extract-plugin
module.exports = {"regionFAQ":"styles_regionFAQ___hOYy","boxFAQ":"styles_boxFAQ__6SYWH","descriptionRegion":"styles_descriptionRegion__nfbJ9"};